module.exports = __webpack_public_path__ + "img/candidate6.51bf79f0.png";